module.exports = __webpack_public_path__ + "static/media/Foxy-Hallway.39ac94de.webp";